export default "__VITE_ASSET__6d01f7e9__"